module.exports = __webpack_public_path__ + "static/media/ad1.294ed109.png";